<template>
  <div>
    <TopNavbar :title="'My Orders'" :bgColor="'bg-red'">
      <div class="order-detail-navbar">
        <div class="home-logo"><img :src="homelogo" /></div>
        <div class="title onHome">Order Processing</div>
      </div>
    </TopNavbar>
    <div class="container">
      <div>
        <van-loading color="#ee2d24" :overlay="false" vertical :text-size="25" :size="100">{{loadingText}}</van-loading>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from '../../components/common/TopNavbar.vue'
import { Toast } from 'vant';
import { getDeliveryProcessInfo } from '@/api/api'
import homelogo from "@/assets/fastorder.logo.png"
import { cartMixin } from '@/mixins/cartMixin'

export default {
  components: {
    TopNavbar
  },
  props: {
  },
  data() {
    return {
      requested: true,
      homelogo: homelogo,
      orderid: 0,
      loadingText: 'System Processing...', // 加载加的提示文字
      isRefresh: true, // 是否自动刷新页面
      isRedirectPage: false, // 是否自动自动页面
      redirectUrl: ''//自动跳转页面的URL
    }
  },
  created() {
    const queryParams = this.$route.query
    this.orderid = queryParams.orderid
    this.initData()
  },
  mixins: [cartMixin],
  methods: {
    initStatus() {
      if (this.isRedirectPage && this.redirectUrl != '') {
        this.$router.push({ path: this.redirectUrl })
      }else{
        if(this.requested && this.isRefresh){
          setTimeout(() => {
            this.initData()
          }, 60000);
        }
      }
    },
    initData() {
      let queryParams = {
        i: 2,
        c: 'entry',
        do: 'delivery_order_processing',
        m: 'weisrc_dish',
        orderid: parseInt(this.orderid),
        append: 1,
      }
      getDeliveryProcessInfo('/app/index.php', queryParams).then(res => {
        console.log('.......................getDeliveryProcessInfo', res);
        this.requested = true
        const { loadingText, isRefresh, isRedirectPage, redirectUrl } = res.data
        this.loadingText = loadingText || 'System Processing...'
        this.isRefresh = isRefresh || true
        this.isRedirectPage = isRedirectPage || false
        this.redirectUrl = redirectUrl || ''
        this.initStatus()
      }).catch((error) => {
        console.log('.......................error', error)
        this.requested = true
        this.initStatus()
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');

.title {
  font-weight: 700;
}
.order-detail-navbar {
  width: 100%;
  display: flex;
  align-items: center;
  .home-logo {
    width: 20px;
    height: 20px;
    img {
      width: 100%;
    }
  }
}
.onHome {
  padding: 4px 0;
  flex: 1;
  text-align: center;
}
.container{
  padding: 150px 10px;
}
</style>

